import React from "react";
import { useAuth } from "../hooks/useAuth";

const DebugAuth: React.FC = () => {
  const { user } = useAuth();
  const token = localStorage.getItem("token");

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Authentication Debug</h1>

      <div className="bg-gray-100 p-4 rounded-lg mb-4">
        <h2 className="text-lg font-semibold mb-2">Token in localStorage:</h2>
        <p className="font-mono text-sm break-all">
          {token ? token : "No token found"}
        </p>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg mb-4">
        <h2 className="text-lg font-semibold mb-2">Current User:</h2>
        <pre className="text-sm">
          {user ? JSON.stringify(user, null, 2) : "No user found"}
        </pre>
      </div>

      <div className="bg-gray-100 p-4 rounded-lg">
        <h2 className="text-lg font-semibold mb-2">Auth Header Test:</h2>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded mr-2"
          onClick={async () => {
            try {
              const API_URL =
                import.meta.env.VITE_BACKEND_URL || "http://localhost:5000";
              const response = await fetch(`${API_URL}/api/auth/profile`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              });
              const data = await response.json();
              console.log("Profile response:", data);
              alert(`Profile response: ${JSON.stringify(data, null, 2)}`);
            } catch (error) {
              console.error("Profile fetch error:", error);
              alert(`Error: ${error}`);
            }
          }}
        >
          Test Profile API
        </button>

        <button
          className="bg-green-500 text-white px-4 py-2 rounded"
          onClick={async () => {
            try {
              const API_URL =
                import.meta.env.VITE_BACKEND_URL || "http://localhost:5000";
              const response = await fetch(
                `${API_URL}/api/expenses?page=1&limit=10`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  },
                }
              );
              const data = await response.json();
              console.log("Expenses response:", data);
              alert(`Expenses response: ${JSON.stringify(data, null, 2)}`);
            } catch (error) {
              console.error("Expenses fetch error:", error);
              alert(`Error: ${error}`);
            }
          }}
        >
          Test Expenses API
        </button>
      </div>
    </div>
  );
};

export default DebugAuth;
